import { ComponentIds, DisplayNameComponent, HierarchyUtils, LocalTransformComponent, Transform, UnserializableEntityComponent, Vector, ViewerObjectComponent } from '@inter-ikea-core/core';
import { PlannerEcsMultiSystem } from './System';
const BOX_DISPLAYNAME = 'Frame Box Selection Component';
/**
 * This system will add an invisible view object in the back of frames
 * so that the user can click "anywhere" between them and still select the frame
 */
export class InteractableFrameSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'InteractableFrameSystem', [
            ComponentIds.IN_SCENE_COMPONENT_ID,
            ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID
        ]);
        this.placementService = coreApi.placementService;
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID) {
            const isFrame = entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID);
            if (isFrame && !this.hasInteractableBox(entity)) {
                this.createBoxEntity(entity);
            }
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID) {
            const entityAfterLoadingSnapshot = oldComponent.entity;
            const stateBeforeLoadingSnapshot = oldComponent
                .entityStateBeforeLoadingSnapshot;
            if (!entityAfterLoadingSnapshot && stateBeforeLoadingSnapshot) {
                const viewerObjectComponent = stateBeforeLoadingSnapshot.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
                if (!viewerObjectComponent)
                    return;
                viewerObjectComponent.viewerObject.deleteObject();
            }
            else if (entityAfterLoadingSnapshot && !stateBeforeLoadingSnapshot) {
                const isFrame = entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID);
                if (isFrame && !this.hasInteractableBox(entity)) {
                    this.createBoxEntity(entity);
                }
            }
        }
    }
    createBoxEntity(frame) {
        const size = frame.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size.vector;
        if (!size)
            return;
        const entityManager = this.coreApi.getServices().entityManager;
        const compartment = entityManager.createEntity();
        HierarchyUtils.setParent(compartment, frame);
        compartment.addComponent(new DisplayNameComponent(BOX_DISPLAYNAME));
        compartment.addComponent(new UnserializableEntityComponent());
        compartment.addComponent(new LocalTransformComponent(new Transform(new Vector(0, 0, -size.Z / 2 + 5))));
        const model = this.coreApi.viewer.createBox(size.X, size.Y, 5, frame);
        model.registerInputEvents();
        model.setBaseColor(1, 1, 1);
        model.setTransparency(0.01);
        compartment.addComponent(new ViewerObjectComponent(model));
    }
    hasInteractableBox(entity) {
        return HierarchyUtils.children(entity).some(e => e.getComponent(ComponentIds.DISPLAY_NAME_COMPONENT_ID)?.name ===
            BOX_DISPLAYNAME);
    }
}
//# sourceMappingURL=InteractableFrameSystem.js.map